module.exports = __webpack_public_path__ + "media/images/presentation_plateforme-bb5010d2ef3d2496bd2e5af5d00bbb4c.pdf";